import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Servicios from './pages/Servicios';
import Contacto from './pages/Contacto';
import QuienesSomos from './pages/QuienesSomos';
import Presupuesto from './pages/Presupuesto';
import ProyectoPersonalizado from './pages/ProyectoPersonalizado';
import GrabadoLaser from './pages/GrabadoLaser';
import Impresion3D from './pages/Impresion3D';
import RegalosPersonalizados from './pages/RegalosPersonalizados';
import Faq from './pages/Faq';
import Terminos from './pages/Terminos';
import Cookies from './pages/Cookies';
import Privacidad from './pages/Privacidad';
import Trabajos from './pages/Trabajos';
import './styles/app.css';

// Componente para hacer scroll al top al cambiar de página
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <div className="app">
      <ScrollToTop />
      <a href="#main-content" className="skip-link">
        Saltar al contenido principal
      </a>
      
      <Header />
      
      <main id="main-content" className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/servicios" element={<Servicios />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/quienes-somos" element={<QuienesSomos />} />
          <Route path="/presupuesto" element={<Presupuesto />} />
          <Route path="/proyecto-personalizado" element={<ProyectoPersonalizado />} />
          <Route path="/grabado-laser-asturias" element={<GrabadoLaser />} />
          <Route path="/impresion-3d-asturias" element={<Impresion3D />} />
          <Route path="/regalos-personalizados-asturias" element={<RegalosPersonalizados />} />
          <Route path="/preguntas-frecuentes" element={<Faq />} />
          <Route path="/terminos" element={<Terminos />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/privacidad" element={<Privacidad />} />
          <Route path="/trabajos" element={<Trabajos />} />
        </Routes>
      </main>
      
      <Footer />
    </div>
  );
}

export default App;
